import { ApiManager } from '../../core/api-manager';
import { DataManager } from '../../core/data-manager';
import { settings } from '../../config/settings';
import { LanguageProvider } from '../../core/language-provider';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';



export const actions = {
    DataGridRow: {
        sample: [
            {
                label: "Test",
                icon: "share",
                func: test
            }
        ],
        gyv_customer_order: [
            {
                label: "Anteprima",
                icon: "print",
                func: customerOrderPreview
            }
        ],
        gyv_supplier_order: [
            {
                label: "Anteprima",
                icon: "print",
                func: supplierOrderPreview
            }
        ],
        gyv_customer_offer: [
            {
                label: "Anteprima",
                icon: "print",
                func: customerOfferPreview
            }
        ],
        gyv_invoice: [
            {
                label: "Elimina",
                icon: "trash",
                func: deleteInvoice
            }
        ],
    },
    ModalDetailsFooter: {
        sample: [
            {
                label: "Test",
                icon: "share",
                func: test
            }
        ],
        gyv_customer_order: [
            {
                label: "Anteprima",
                icon: "print",
                func: customerOrderPreview
            }
        ],
        gyv_supplier_order: [
            {
                label: "Anteprima",
                icon: "print",
                func: supplierOrderPreview
            }
        ],
        gyv_customer_offer: [
            {
                label: "Anteprima",
                icon: "print",
                func: customerOfferPreview
            }
        ]
    }
}

function test(item) {
    console.warn("test", item)
}

function customerOrderPreview(item, navigate) {
    navigate('/page/CustomerOrderPreview?id=' + item.id)
}

function customerOfferPreview(item, navigate) {
    navigate('/page/CustomerOfferPreview?id=' + item.id)
}


function supplierOrderPreview(item, navigate) {
    navigate('/page/SupplierOrderPreview?id=' + item.id)
}


async function deleteInvoice(item, navigate, refreshData) {
    const isPending = !item.status || item.status.value === '0_PENDING';
    if (!isPending) {
        Swal.fire({
            title: 'Attenzione',
            text: 'Solo le fatture in attesa possono essere eliminate.',
            icon: 'warning',
            confirmButtonColor: '#ffc107'
        });
        return;
    }

    const result = await Swal.fire({
        title: 'Conferma eliminazione',
        text: 'Sei sicuro di voler eliminare questa fattura?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#dc3545',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Sì, elimina',
        cancelButtonText: 'Annulla'
    });

    if (!result.isConfirmed) {
        return;
    }

    try {
        var res = await ApiManager.sendAuthenticatedRequest('/custom/hard_delete_invoice', {id: item.id});
        if (res.success === 1) {
            refreshData();
            Swal.fire({
                title: 'Eliminata!',
                text: 'Fattura eliminata con successo.',
                icon: 'success',
                confirmButtonColor: '#198754'
            });
            
        } else {
            Swal.fire({
                title: 'Errore',
                text: 'Errore nella eliminazione della fattura.',
                icon: 'error',
                confirmButtonColor: '#dc3545'
            });
        }
    } catch (error) {
        Swal.fire({
            title: 'Errore',
            text: error.message || 'Errore nella eliminazione della fattura.',
            icon: 'error',
            confirmButtonColor: '#dc3545'
        });
    }
}